<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
    </div>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <locale />
    </b-navbar-nav>

    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0 text-capitalize">
              {{ username }}
            </p>
            <span
              v-if="userData.typeId"
              class="user-status"
            >
              {{ $t(`userType.${userData.typeId}`) }}
            </span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="profilePicture"
            :text="avatarText(name)"
            class="badge-minimal"
            badge-variant="success"
          >
            <feather-icon
              v-if="!name"
              icon="UserIcon"
              size="22"
            />
          </b-avatar>
        </template>

        <b-dropdown-item
          link-class="d-flex align-items-center"
          :to="{ name: 'account-setting' }"
        >
          <feather-icon
            size="16"
            icon="SettingsIcon"
            class="mr-50"
          />
          <span>{{ $t("general.setting") }}</span>
        </b-dropdown-item>

        <b-dropdown-divider />

        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="logout"
        >
          <feather-icon
            size="16"
            icon="LogOutIcon"
            class="mr-50"
          />
          <span>{{ $t("general.logout") }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from 'bootstrap-vue'
import { logout } from '@/auth/utils'
import { avatarText } from '@core/utils/filter'
import Locale from '@/layouts/components/app-navbar/Locale.vue'
import db from '@/libs/firestore-db'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import requestDepositVMenu from '@/navigation/vertical/menu/requestDeposit'
import requestWithdrawVMenu from '@/navigation/vertical/menu/requestWithdraw'
import requestDepositHMenu from '@/navigation/horizontal/menu/requestDeposit'
import requestWithdrawHMenu from '@/navigation/horizontal/menu/requestWithdraw'
import Repository from '@/repositories/RepositoryFactory'

const DepositRepository = Repository.get('depositRequest')

export default {
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,

    // Navbar Components
    Locale,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      avatarText,
      listenFbNotification: null,
      time: null,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.name
        ? this.$store.state.profile
        : JSON.parse(localStorage.getItem('userData'))
    },
    name() {
      if (this.$store.state.profile.name) {
        return this.$store.state.profile.name
      }

      return this.userData?.name
    },
    username() {
      if (this.$store.state.profile.username) {
        return this.$store.state.profile.username
      }

      return this.userData.username
    },
    profilePicture() {
      if (this.$store.state.profile.name) {
        return this.$store.state.profile.profilePicture
      }

      return this.userData.profilePicture
    },
  },
  mounted() {
    this.listenNotification()

    if (this.userData?.id && this.userData?.actionBefore) {
      this.countDeposit()
    } else {
      this.setBadge({
        deposit: 0,
        withdrawal: 0,
      })
    }
  },
  beforeDestroy() {
    // eslint-disable-next-line no-unused-expressions
    this.listenFbNotification && this.listenFbNotification()
  },
  methods: {
    listenNotification() {
      if (!this.userData?.id || !this.userData?.actionBefore) {
        return
      }

      // eslint-disable-next-line no-unused-expressions
      this.listenFbNotification && this.listenFbNotification()
      this.listenFbNotification = db
        .collection('admin')
        .doc(`agent_${this.userData.id}`)
        .onSnapshot(response => {
          const message = response.get('notify_msg')
          const time = response.get('notify_time')
          if (message && this.time && this.time !== time) {
            this.$toast({
              component: ToastificationContent,
              icon: 'BellIcon',
              position: 'top-right',
              autoClose: 5000,
              props: {
                title: message,
                icon: 'BellIcon',
                variant: 'success',
                text: '',
              },
            })
            this.countDeposit()
          }
          this.time = time
        })
    },
    countDeposit() {
      DepositRepository.count().then(response => {
        const data = response.data?.data
        this.setBadge(data)
      })
    },
    setBadge(data) {
      if (requestDepositVMenu.length) {
        requestDepositVMenu[0].tag = data.deposit
      }
      if (requestWithdrawVMenu.length) {
        requestWithdrawVMenu[0].tag = data.withdrawal
      }
      if (requestDepositHMenu.length) {
        requestDepositHMenu[0].tag = data.deposit
      }
      if (requestWithdrawHMenu.length) {
        requestWithdrawHMenu[0].tag = data.withdrawal
      }
      this.$store.commit('profile/SET_BADGE', data)
    },
    logout() {
      logout()

      // Redirect to login page
      this.$router.push({ name: 'login' })
    },
  },
}
</script>
